import { BufReader, BufWriter, } from './internal.js';
import { base16 } from './support/base.js';
/**
 * Lock Types
 *
 * - Frozen     - can't be called; can't be locked; (can be loaded?)
 * - None       - anyone can call; anyone can lock; (default type)
 * - Address    - requires sig to call; requires sig to lock;
 * - Caller     - caller must be parent; new lock must be set by parent;
 * - Anyone     - anyone can call; can't be locked; (must be set in own constructor)
 */
export var LockType;
(function (LockType) {
    LockType[LockType["FROZEN"] = -1] = "FROZEN";
    LockType[LockType["NONE"] = 0] = "NONE";
    LockType[LockType["ADDRESS"] = 1] = "ADDRESS";
    LockType[LockType["JIG"] = 2] = "JIG";
    LockType[LockType["PUBLIC"] = 3] = "PUBLIC";
})(LockType || (LockType = {}));
/**
 * Output Lock
 *
 * Every output has a Lock which determines who can call methods and update the
 * instance.
 */
export class Lock {
    type;
    data;
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
    static fromBytes(bytes) {
        if (!ArrayBuffer.isView(bytes)) {
            throw Error('The first argument to `Lock.fromBytes()` must be a `Uint8Array`');
        }
        const buf = new BufReader(bytes);
        return buf.read(LockSerializer);
    }
    static fromJson(json) {
        return new Lock(json.type, base16.decode(json.data));
    }
    toBytes() {
        const buf = new BufWriter();
        buf.write(LockSerializer, this);
        return buf.data;
    }
    toHex() {
        return base16.encode(this.toBytes());
    }
    toJson() {
        return { type: this.type, data: base16.encode(this.data) };
    }
}
/**
 * Lock Serializer object - implements the Serializable interface.
 */
export const LockSerializer = {
    read(buf) {
        const type = buf.readU8();
        let data;
        if (type === LockType.ADDRESS) {
            data = buf.readFixedBytes(20);
        }
        else if (type == LockType.JIG) {
            data = buf.readFixedBytes(34);
        }
        else {
            data = buf.readFixedBytes(0);
        }
        return new Lock(type, data);
    },
    write(buf, lock) {
        buf.writeU8(lock.type);
        buf.writeFixedBytes(lock.data);
        return buf;
    }
};
